import { ref } from "vue";
import { usePage } from "@inertiajs/vue3"

export default {
    mounted(el, binding) {
        const editable = ref(usePage().props.editable)
        el.contentEditable = editable.value;
        el.innerText = binding.value;

        el.addEventListener("input", () => {
            binding.instance[binding.expression] = el.innerText;
        });

        el.addEventListener("blur", () => {
            console.log("Gespeichert:", binding.expression, el.innerText);
        });
    },
    updated(el, binding) {
        if (el.innerText !== binding.value) {
            el.innerText = binding.value;
        }
    }
};
